module.exports = __webpack_public_path__ + "static/media/RHInSwingDark.b91e465a.svg";